import { render } from "./qualityTaskViewer.vue?vue&type=template&id=70473730&scoped=true"
import script from "./qualityTaskViewer.vue?vue&type=script&lang=js"
export * from "./qualityTaskViewer.vue?vue&type=script&lang=js"

import exportComponent from "D:\\_2021\\项目管理系统\\TYH_office_automation\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70473730"]])

export default __exports__